import { a as n, j as s } from "../../../jsx-runtime-c20f6c15.mjs";
import i from "clsx";
import "react";
const t = "_container_363ya_1", _ = "_xs_363ya_88", c = "_sm_363ya_95", d = "_md_363ya_102", e = "_lg_363ya_109", l = "_jumbo_363ya_116", m = {
  container: t,
  xs: _,
  sm: c,
  md: d,
  lg: e,
  jumbo: l
}, r = {
  xSmall: m.xs,
  small: m.sm,
  medium: m.md,
  large: m.lg,
  jumbo: m.jumbo
};
function j({ size: o, className: a }) {
  return /* @__PURE__ */ n("div", { className: i(r[o], m.container, a), children: [
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {}),
    /* @__PURE__ */ s("div", {})
  ] });
}
export {
  j as default
};
